import {createContext, useContext, useEffect, useReducer, useRef} from "react";
import {initialState, reducer, setCouponList, setLoading, setQuery, setTabActive, setTotal} from "./reducer";

import {useQueryMyCouponReceive} from "../../../../api/couponReceive";
import {mediaMatch} from "../../../../utils";

const Context = createContext(initialState);

function MyCouponController() {
  const { state, dispatch } = useMyCouponContext();
  const { loading, getList } = useQueryMyCouponReceive();
  const isMdmax = mediaMatch.isMdmax;
  const listCache = useRef([]); // 直接拿缓存中的list
  const queryCache = useRef(state.query); // 直接拿缓存中的query
  
  const getCouponList = async (query) => {
    let q = { ...queryCache.current, ...query };
    let { data } = await getList(q);
    
    dispatch(setQuery(q));
    queryCache.current = q;
    
    if (isMdmax) {
      let list = q.page === 1 ? data.records : listCache.current.concat(data.records);
      listCache.current = list;
      dispatch(setCouponList(list));
    } else {
      dispatch(setCouponList(data.records));
    }
    dispatch(setTotal(Number(data.total)));
  };
  
  const setActive = (active) => {
    dispatch(setTabActive(active));
    let status = active ? active : queryCache.useStatus;
    getCouponList({
      useStatus: active,
      page: 1
    });
  };
  
  useEffect(() => {
    dispatch(setLoading(loading));
  }, [loading]);
  
  return {
    loading,
    setActive,
    getCouponList
  };
}

function useMyCouponContext() {
  const { state, dispatch } = useContext(Context);
  
  return {
    state,
    dispatch,
  };
}

export {useMyCouponContext, MyCouponController};

export default function MyCouponContext({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  
  return (
    <Context.Provider
      value={{ state, dispatch }}
      reducer={reducer}>
      {children}
    </Context.Provider>
  );
}
